( function($) {
	var $cards = $('.about-people').find('.card'),
		$info = $('.more-info');

	if (!$info || $cards.length === 0) {
		return;
	}

	if (history) {
		history.replaceState({
			closeInfoWindow: true
		}, 'About US - Peter C. Ghiz Law', null);
	}

	var $infoInner = $info.find('.more-info__inner'),
		$infoImage = $info.find('.image'),
		$infoName = $info.find('.name'),
		$infoEducation = $info.find('.education'),
		$infoText = $info.find('.text'),

		$closeButton = $info.find('.close-button'),
		$selectedCard = null,
		startPosition = {top: 0, left: 0};

	$cards.find('.card__link').on('click', function(event) {
		$selectedCard = $(event.target).parents('.card').first();
		openWindow(event);
	});

	$closeButton.on('click', function(event) {
		if (history) {
			history.back();
		}
		else {
			closeWindow(event);
		}
	});

	$(document).on('keyup', function(event) {
		var key = typeof event.keyCode !== 'undefined' ? event.keyCode : event.which;

		// If ESC key pressed
		if (event.keyCode == 27) {
			if (history) {
				history.back();
			}
			else {
				closeWindow(event);
			}
		}
	});

	window.onpopstate = function(event) {
		if (event.state) {
			if (event.state.closeInfoWindow || $infoInner.is(':visible')) {
				closeWindow(event);
			}
			else if (event.state.openInfoWindow && event.state.card) {
				$selectedCard = $('.about-people').find('#' + event.state.card + '.card');
				openWindow();
			}
		}
	}

	$(window).on('resize', function(event) {
		var menuHeight = $('#main-menu').outerHeight();
		$info.css({
			'top': menuHeight,
			'height': $(window).outerHeight() - menuHeight + 'px'
		});
	});


	function openWindow(event) {
		if (!$selectedCard) {
			return;
		}

		// Find the starting position for the info window
		if (event && event.target) {
			var rect = event.target.getBoundingClientRect();
			startPosition = {
				top: rect.top + event.target.offsetHeight/2,
				left: rect.left + event.target.offsetWidth/2
			};
		}
		else {
			startPosition = {
				top: $(window).outerHeight() / 2,
				left: $(window).outerWidth() / 2
			}
		}

		// Move info window to the starting position on the clicked button
		$info.css(startPosition);

		// Get new info
		var person = {
			imgURL: $selectedCard.find('.card__header').css('background-image').slice(4, -1).replace(/"/g, ""),
			name: $selectedCard.find('.card__title').text(),
			education: $selectedCard.find('.card__subtitle').text(),
			text: $selectedCard.find('.full-text').html()
		};

		// Clear old info
		$infoImage.empty();
		$infoName.empty();
		$infoEducation.empty();
		$infoText.empty();

		// Add new info
		$infoImage.append('<img src="' + person.imgURL + '" />');
		$infoName.text(person.name);
		$infoEducation.text(person.education);
		$infoText.html(person.text);

		// Hide body overflow and expand window
		var menuHeight = $('#main-menu').outerHeight();
		$('body').css('overflow', 'hidden');

		$info.animate({
			'top': menuHeight,
			'left': '0',
			'width': '100%',
			'height': $(window).outerHeight() - menuHeight + 'px'
		}, 300, function() {
			if (history) {
				if (history.state.openInfoWindow) {
					history.replaceState({
						openInfoWindow: true,
						card: $selectedCard.attr('id'),
					}, 'About ' + person.name, null);
				}
				else {
					history.pushState({
						openInfoWindow: true,
						card: $selectedCard.attr('id'),
					}, 'About ' + person.name, null);
				}
			}

			$closeButton.fadeIn(300);

			$infoInner.show();
			$infoInner.scrollTop(0);
			$infoInner.animate({
				'opacity': 1
			}, 300);
		});
	}

	function closeWindow(event) {
		// Move the info window back to the starting position and hide it
		$info.animate({
			'top': startPosition.top,
			'left': startPosition.left,
			'width': '0',
			'height': '0'
		}, 300);

		$closeButton.fadeOut(300);

		$infoInner.animate({
			'opacity': '0'
		}, 300, function() {
			$infoInner.hide();
		});

		$('body').css('overflow', 'initial');
	}
} )(jQuery);